import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { sentryInit } from '@ankr.com/raas-utils';
import * as Sentry from '@sentry/react';

import App from './App';
import reportWebVitals from './reportWebVitals';

sentryInit(import.meta.env.VITE_SENTRY_DSN);

createRoot(document.getElementById('root') as HTMLElement).render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
    <StrictMode>
      <App />
    </StrictMode>
  </Sentry.ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
